module.exports = __webpack_public_path__ + "static/media/krungsi.93fb3002.jpg";